import { FINAL_STATUSES } from 'shared/widgets/RequestsBankOpsImport/constants/importFileStatuses';
import { useGetActiveImportById } from 'shared/widgets/RequestsBankOpsImport/hooks/useGetActiveImportById';
import { useGetActiveImportId } from 'shared/widgets/RequestsBankOpsImport/hooks/useGetActiveImportId';
import { useGetActiveImportInvalid } from 'shared/widgets/RequestsBankOpsImport/hooks/useGetActiveImportInvalid';
import {
  ImportFile,
  ImportFileStatuses,
  ImportFileStatusesValue,
  ImportRow,
} from 'types/embedded/bankOperation';
import { getId } from 'utils/getId';

const getImportErrors = (rows: ImportRow[]) => {
  return rows
    .filter((row) => Object.keys(row.errorMessages || {}).length > 0)
    .map((row) => {
      const messages = Object.values(row.errorMessages).flat();
      return messages.map((msg) => `[${row.numberRow}] - ${msg}`);
    })
    .flat();
};

const calcImportProgress = (activeImport: ImportFile | undefined) => {
  if (!activeImport?.totalRows) {
    return 0;
  }

  if (FINAL_STATUSES.includes(getId(activeImport.status) as ImportFileStatuses)) {
    return 100;
  }

  return activeImport?.totalRows
    ? Math.min(100, Math.max(0, (activeImport.processedRows / activeImport.totalRows) * 100))
    : 0;
};

export const useImportFileDetails = () => {
  const { data } = useGetActiveImportId();
  const activeImportId = getId(data?.id);

  const { data: activeImport } = useGetActiveImportById(activeImportId);
  const activeImportStatus = getId(activeImport?.status) as ImportFileStatusesValue;
  const activeImportProgress = calcImportProgress(activeImport);

  const { data: activeImportInvalid = [], isFetching: isLoadingErrors } = useGetActiveImportInvalid(
    activeImportId,
    activeImportStatus,
  );
  const errors = getImportErrors(activeImportInvalid);

  return {
    activeImportStatus,
    activeImportProgress,
    errors,
    isLoadingErrors,
    activeImport,
    hasActiveImport: Boolean(activeImportId),
  };
};
